/** Formats part of total as a whole percentage; a nonzero share below 1 % is "< 1". */
export function shareOf(part: number, total: number): string {
  if (total <= 0 || part <= 0) {
    return '0';
  }

  const share = (part / total) * 100;

  return share < 1 ? '< 1' : String(Math.round(share));
}
